// client/src/components/indicadores/ReportPageLayout.js
import React, { useState, useEffect } from 'react';
import PageHeader from '../layout/PageHeader';
import FilterBar from './FilterBar';
import { Filter as FilterIcon } from 'lucide-react';
import KpiCard from '../dashboard/KpiCard';

// ✅ CORREÇÃO: Atualizado para usar unidadeId em vez de enderecoId
const initialFiltersState = {
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(),
    unidadeId: '', // ✅ CORREÇÃO: mudado de enderecoId para unidadeId
    profissionalId: '',
    servicoId: '',
    recursoId: '',
    metodoPagamentoId: '',
    comAgendamento: 'sim',
};

const ReportPageLayout = ({
    icon,
    title,
    onApplyFilters,
    filterOptions,
    enabledFilters,
    isLoading,
    kpiCards = [],
    children, // A prop 'children' é a chave para exibir o conteúdo
    initialFilters: pageInitialFilters,
    extraActions, // ✅ slot opcional pra ações extras no cabeçalho (ex.: Baixar PDF) — retrocompatível, páginas que não passam continuam idênticas
}) => {
    const [showFilters, setShowFilters] = useState(false);
    // Usa os filtros iniciais da página, se fornecidos
    const [filters, setFilters] = useState(pageInitialFilters || initialFiltersState);

    // Efeito para aplicar os filtros iniciais na primeira renderização
    useEffect(() => {
        if (onApplyFilters) {
            onApplyFilters(filters);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleApply = () => {
        if (onApplyFilters) {
            onApplyFilters(filters);
        }
        setShowFilters(false);
    };

    const handleClear = () => {
        const resetState = pageInitialFilters || initialFiltersState;
        setFilters(resetState);
        if (onApplyFilters) {
            onApplyFilters(resetState);
        }
    };

    const pageActions = (
        <>
            <button
                onClick={() => setShowFilters(prevState => !prevState)}
                className="action-button action-button-secondary"
            >
                <FilterIcon size={18} className="icon" />
                {showFilters ? 'Ocultar Filtros' : 'Exibir Filtros'}
            </button>
            {extraActions}
        </>
    );

    return (
        <div className="page-management-container report-page">
            <PageHeader icon={icon} title={title} actions={pageActions} />

            {showFilters && (
                <div className="content-panel">
                    <h3 className="panel-title">Filtros</h3>
                    <FilterBar
                        filters={filters}
                        setFilters={setFilters}
                        onApply={handleApply}
                        onClear={handleClear}
                        options={filterOptions}
                        enabledFilters={enabledFilters}
                        isLoading={isLoading}
                    />
                </div>
            )}

            {kpiCards.length > 0 && (
                <div className="dashboard-grid" style={{ marginTop: '1.5rem' }}>
                    {kpiCards.map((kpi, index) => (
                        <KpiCard
                            key={index}
                            title={kpi.title}
                            value={kpi.value}
                            prefix={kpi.prefix}
                            isLoading={isLoading}
                            icon={kpi.icon} // ✅ CORREÇÃO: Adicionado suporte para ícones
                            subtitle={kpi.subtitle} // ✅ CORREÇÃO: Adicionado suporte para subtítulos
                            description={kpi.description} // ✅ CORREÇÃO: Adicionado suporte para descrições
                        />
                    ))}
                </div>
            )}
            
            {/* Renderiza o conteúdo da página (a tabela) */}
            <div style={{ marginTop: '1.5rem' }}>
                {children}
            </div>
        </div>
    );
};

export default ReportPageLayout;